import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { IndicatorConfigActions } from './indicator-config-actions';
import { IConfigState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface IIndicatorConfigActionsProps {
  readonly warning: boolean;
}

export interface IIndicatorConfigActionsStateProps extends IIndicatorConfigActionsProps {
  readonly ui: IUIState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
}

export type IIndicatorConfigActionsConnectProps = IIndicatorConfigActionsStateProps
  & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState, props: IIndicatorConfigActionsProps): IIndicatorConfigActionsStateProps {
  return {
    ui: state.ui,
    upload: state.upload,
    config: state.config,
    ...props
  };
}

export const IndicatorConfigActionsContainer: React.ComponentClass<IIndicatorConfigActionsProps>
  = ReactRedux.connect(mapStateToProps)(IndicatorConfigActions);
